import { Gingivitis } from "./gingivitis";
import { Plaque } from "./plaque";
import { BoneLoss } from "./bone-loss";
import { GingivalOvergrowth } from "./gingival-overgrowth";
import { GummySmile } from "./gummy-smile";
import { LargeSinus } from "./large-sinus";
import { Mobility } from "./mobility";
import { Recession } from "./recession";
import { Periodontitis } from "./periodontitis";

export const conditions = [
  BoneLoss,
  GingivalOvergrowth,
  Gingivitis,
  GummySmile,
  LargeSinus,
  Mobility,
  Plaque,
  Recession,
  Periodontitis,
];



// WEBPACK FOOTER //
// /app/src/app/core/store/plan-editor/diagnosis/conditions/perio/index.ts